export default [
  'clickLeave',
  'clickMainButton',
  'clickMinimize',
  'clickOptIn',
  'clickSubmitFeedback',
  'clickTellMeMore'
]
